import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { showModal } from '../../../../actions';

import { usePageId } from '../../../../helpers/PageIdContext';

const DownloadButton = ({ collectionUuid, onShowModal }) => {
  const pageId = usePageId();

  const openDownloadModal = useCallback((e) => {
    e.preventDefault();

    if (!collectionUuid) {
      return;
    }

    onShowModal('DownloadModal', {
      className: 'modal-download',
      files: [],
      collections: [{ uuid: collectionUuid }],
      pageId,
      backdrop: true,
    });
  }, [collectionUuid, onShowModal, pageId]);

  return (
    <button type="button" className="download-button" onClick={openDownloadModal}>
      <i className="fas fa-download" />
    </button>
  );
};

DownloadButton.propTypes = {
  collectionUuid: PropTypes.string,
  onShowModal: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  onShowModal: (modalName, params) => dispatch(showModal(modalName, params)),
});

export default connect(null, mapDispatchToProps)(DownloadButton);
